<template>
  <div class="ml-3 pa-2">
    <div class="condition-panel">
      <div class="d-flex align-items-center justify-content-around flex-grow-1">
        <dropdown
          :options="keyOptions"
          :value="condition.key"
          :onChange="val => (condition.key = val)"
          placeholder="Key"
        />

        <span
          class="">is equal to</span>

        <dropdown
          class=""
          :options="valueOptions"
          :value="condition.value"
          :onChange="val => (condition.value = val)"
          placeholder="Value"
        />
      </div>
      <a
        class="icon-btn delete ml-1"
        @click="$emit('remove')"
        v-tooltip="{ content: `Delete condition`, delay: 200 }"
      ></a>
    </div>
  </div>
</template>

<script>
import Dropdown from "./Dropdown";

export default {
  name: "TemplateBuilderCondition",
  components: {Dropdown},
  props: {
    condition: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    keyOptions() {
      return [
        {
          text: 'Type',
          value: 'type'
        },
        {
          text: 'Category',
          value: 'categoryId'
        }
      ]
    },
    valueOptions(){
      switch(this.condition.key){
        case 'type':{
          return [
            { value: 'Tender', text: 'Tender' },
            { value: 'Contract Renewal', text: 'Contract Renewal' },
            { value: 'Negotiation', text: 'Negotiation' },
            { value: 'Exit', text: 'Exit' },
            { value: 'Process Review', text: 'Process Review' },
            { value: 'Self-Service', text: 'Self-Service' },
            { value: 'Other', text: 'Other' },
          ]
        }
        case 'categoryId':{
          return Object.keys(this.$store.getters.categories).map(key => {
            const cat = this.$store.getters.categories[key];
            return {value: cat.id, text: cat.name};
          });
        }
        default: return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.condition-panel {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border: 1px solid #E2E5EC;
  border-radius: 4px;

  :first-child {
    margin-left: 0;
  }

  :nth-child {
    margin-left: 40px;
  }

  //&:before{
  //    content: "hi";
  //    position: absolute;
  //    top: -26px;
  //    left: 0px;
  //    border: 1px dashed #9DA1A6;
  //    width: 16px;
  //    height: 100%;
  //}
}
</style>
